import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Spin } from "antd";
import classNames from "classnames";
import Sticky from "react-stickynode";
import { Header } from "../header.js";
import { TreeNode } from "./node.js";
import { SearchBox } from "./searchBox.js";
import { useFolderTree } from "../../contexts/folderTree.js";
import { useTreeInteraction } from "../../contexts/treeInteraction.js";
import { ResizeButton } from "../toolbar/resizeButton.js";
const TreePadContent = ({ treeDomId, children, isSticky, isStickyHeader, headerStickyAttr, treeStickyAttr, isResizable, opposite, minWidth, maxWidth, collapsed, oppositeOffset, innerClassName, storage, onResize, onResizeOpposite, onResizeFinished })=>{
    const { ignoreChildNodes, isTreeLinkDisabled, rootId, allowMultiSelect, creatableDraft, creatableParentId, staticTree, tree, isTreeBusy, isSortableBusy, toggleExpandAll, searchable, searchInputBusy, autoFocusSearchInput, noFoldersTitle, noFoldersDescription, noSearchResult, isCreatableLinkCancel, renderItem } = useFolderTree();
    const { stickyTreeCalculatedTop, searchTerm, resultSelectedNodeIdx, resultTreeBusy, resultTree, handleSearchChange, handleSearchClose, handleSearchBlur, handleSearchKeyDown, getExpandedState, getExpandedNodes, handleNodeExpand, handleCheck, handleToggleAll, registerSortableUl } = useTreeInteraction();
    const rootCreatableDraft = creatableDraft && creatableParentId == 0 ? creatableDraft : undefined;
    const renderTree = (treeNodes, displayChildren = true, createRootNode = undefined, context = "tree")=>{
        const resultTreeLength = typeof resultSelectedNodeIdx === "number" && resultTree ? resultTree.length : 0;
        const expandedState = getExpandedState();
        const $checkable = context !== "static" && allowMultiSelect;
        const listClassName = classNames({
            "aiot-disable-links": isTreeLinkDisabled,
            "aiot-sortable-one": treeNodes.length === 1
        }, `aiot-context-${context}`);
        let i = -1;
        const anyNodeHasChildren = treeNodes.some((n)=>n.childNodes && n.childNodes.length > 0);
        return [
            context === "tree" && anyNodeHasChildren && toggleExpandAll && /*#__PURE__*/ _jsx("div", {
                onClick: handleToggleAll,
                className: classNames("aiot-expander", "aiot-expander-all", {
                    "aiot-open": getExpandedNodes(expandedState).length
                })
            }, "all-expander"),
            /*#__PURE__*/ _jsxs("ul", {
                className: listClassName,
                "data-childs-for": rootId,
                ref: displayChildren ? (ul)=>registerSortableUl(ul ?? undefined, rootId) : undefined,
                children: [
                    treeNodes.map((node)=>{
                        i++;
                        const searchSelected = resultTreeLength > 0 && i % resultTreeLength === resultSelectedNodeIdx % resultTreeLength && !displayChildren;
                        const propSearchSelected = context === "search" ? searchSelected : undefined;
                        const creatableOptsForNode = (target)=>{
                            if (context !== "tree" || resultTree || !creatableDraft || creatableParentId != target.id) {
                                return undefined;
                            }
                            return {
                                $create: creatableDraft
                            };
                        };
                        const createTreeNode = (_node, opts)=>/*#__PURE__*/ _jsx(TreeNode, {
                                searchSelected: propSearchSelected,
                                ..._node,
                                onExpand: handleNodeExpand,
                                onCheck: handleCheck,
                                $checkable: $checkable,
                                expandedState: expandedState,
                                displayChildren: displayChildren && !ignoreChildNodes,
                                onUlRef: displayChildren ? registerSortableUl : undefined,
                                ...creatableOptsForNode(_node),
                                ...opts
                            }, _node.id);
                        return renderItem ? renderItem(createTreeNode, TreeNode, node) : createTreeNode(node);
                    }),
                    !!createRootNode && /*#__PURE__*/ _jsx(TreeNode, {
                        $_create: true,
                        ...createRootNode
                    })
                ]
            }, "list-view")
        ];
    };
    const effectiveSortingBusy = isSortableBusy;
    const bodyHeader = /*#__PURE__*/ _jsx(Header, {});
    const bodyTreeWrapper = stickyTreeCalculatedTop !== undefined ? /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "aiot-nodes",
            children: [
                children,
                staticTree && renderTree(staticTree, false, undefined, "static"),
                staticTree && /*#__PURE__*/ _jsx("hr", {}),
                searchable && /*#__PURE__*/ _jsx(SearchBox, {
                    autoFocus: autoFocusSearchInput,
                    disabled: !tree.length || isCreatableLinkCancel || effectiveSortingBusy,
                    searchTerm: searchTerm,
                    searchInputBusy: searchInputBusy,
                    resultTreeBusy: resultTreeBusy,
                    onChange: handleSearchChange,
                    onBlur: handleSearchBlur,
                    onKeyDown: handleSearchKeyDown,
                    onClose: handleSearchClose
                }),
                /*#__PURE__*/ _jsx(Spin, {
                    spinning: !!isTreeBusy || effectiveSortingBusy,
                    size: "small",
                    style: {
                        minHeight: 50
                    },
                    children: renderTree(resultTree || tree, !resultTree, resultTree ? undefined : rootCreatableDraft, resultTree ? "search" : "tree")
                }),
                tree && !tree.filter((node)=>node.$visible).length && !isTreeBusy && /*#__PURE__*/ _jsx(Alert, {
                    title: noFoldersTitle,
                    description: noFoldersDescription,
                    type: "info",
                    showIcon: true
                }),
                resultTree && !resultTree.length && /*#__PURE__*/ _jsx(Alert, {
                    title: noSearchResult,
                    type: "warning",
                    showIcon: true
                })
            ]
        })
    }) : undefined;
    const treeStickyAttrResolved = {
        top: stickyTreeCalculatedTop,
        ...treeStickyAttr
    };
    const wrapperClassName = classNames("aiot-pad", innerClassName, {
        "aiot-currently-sorting": effectiveSortingBusy
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: wrapperClassName,
        children: [
            isResizable && opposite && /*#__PURE__*/ _jsx(ResizeButton, {
                opposite: opposite,
                minWidth: minWidth,
                maxWidth: maxWidth,
                initialWidth: storage.getItem("width"),
                restoreWidth: storage.getItem("rwidth"),
                containerId: treeDomId,
                onResize: onResize,
                onResizeOpposite: onResizeOpposite,
                onResizeFinished: onResizeFinished,
                oppositeOffset: oppositeOffset ?? 16
            }),
            !collapsed && (isStickyHeader ? /*#__PURE__*/ _jsx(Sticky, {
                className: "aiot-fixed-header",
                ...headerStickyAttr,
                children: bodyHeader
            }) : /*#__PURE__*/ _jsx("div", {
                children: bodyHeader
            })),
            !collapsed && (isSticky ? /*#__PURE__*/ _jsx(Sticky, {
                ...treeStickyAttrResolved,
                children: bodyTreeWrapper
            }) : /*#__PURE__*/ _jsx("div", {
                children: bodyTreeWrapper
            }))
        ]
    });
};
export { TreePadContent };
